import { useAppSelector } from '../store/hooks'
import { PieceDimensionMax } from '../interfaces'
import { EMPTY_PIECE_DIMENSION_MAX } from '../utils/shipmentValidation'

/**
 * Topes por dimensión de pieza (cm) que publica GET /Application/Facturador en
 * `dimensionMax` (params MAXLARGO / MAXALTO / MAXANCHO). Se hidratan en App.tsx
 * tras el login.
 *
 * Devuelve SIEMPRE un objeto: cada dimensión es `null` cuando el parámetro no está
 * configurado para el país — es decir, esa dimensión no tiene tope. También cubre
 * el estado persistido de versiones anteriores, donde `dimensionMax` aún no existe.
 */
export const usePieceDimensionMax = (): PieceDimensionMax =>
  useAppSelector((state) => state.inmutable.dimensionMax) ??
  EMPTY_PIECE_DIMENSION_MAX
